import { render, staticRenderFns } from "./UmanjeniSatForma.vue?vue&type=template&id=62d22c42&scoped=true&"
import script from "./UmanjeniSatForma.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSatForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d22c42",
  null
  
)

export default component.exports